'use client';

import { cn } from '@/lib/utils';
import { ReactNode, forwardRef } from 'react';

interface SectionWrapperProps {
  children: ReactNode;
  className?: string;
  variant?: 'default' | 'dark' | 'light' | 'gradient';
  padding?: 'sm' | 'md' | 'lg' | 'xl';
}

export const SectionWrapper = forwardRef<HTMLElement, SectionWrapperProps>(
  function SectionWrapper(
    {
      children,
      className,
      variant = 'default',
      padding = 'md',
    },
    ref
  ) {
    const paddingClasses = {
      sm: 'py-8 md:py-12',
      md: 'py-12 md:py-24',
      lg: 'py-16 md:py-32',
      xl: 'py-20 md:py-40',
    };

    const variantClasses = {
      default: 'bg-white dark:bg-black border-t border-gray-200 dark:border-gray-900',
      dark: 'bg-gray-900 dark:bg-gray-950 border-t border-gray-800 dark:border-gray-900',
      light: 'bg-white dark:bg-black border-t border-gray-200 dark:border-gray-800',
      gradient: 'bg-gradient-to-b from-gray-50 to-white dark:from-gray-950 dark:to-black border-t border-gray-200 dark:border-gray-900',
    };

    return (
      <section
        ref={ref}
        className={cn(
          'relative overflow-hidden',
          variantClasses[variant],
          paddingClasses[padding],
          className
        )}
      >
        <div className="container mx-auto px-4 relative z-10">
          {children}
        </div>
      </section>
    );
  }
);

